export const mobile = '(max-width: 599px)';
export const tablet = '(min-width: 600px) and (max-width: 1024px)';
export const PC = '(min-width: 1025px)';
